/**
 * The frontend element type for a stored element.
 *
 * Most widgets share the `widget` type, but TIMELINE, KANBAN and CALENDAR need the canvas data
 * sources and (for the board) the write context, so each has its own element type and renderer.
 */
export function resolveElementType(
  rawType: string,
  config: Record<string, unknown> | null | undefined,
): string {
  if (rawType !== "widget") return rawType;
  switch (config?.widget_type) {
    case "RELATED_RECORDS":
      return "related_records";
    case "TIMELINE":
      return "timeline";
    case "KANBAN":
      return "kanban";
    case "HIERARCHY":
      return "hierarchy";
    case "CALENDAR":
      return "calendar";
    default:
      return rawType;
  }
}
